
import { Container } from "@mui/system";
import { Grid, Typography } from '@mui/material';
import globals from "../globals";

const RefundPolicyPage = () => {
    return (
        <Container>
            <Grid container justifyContent={'center'} textAlign={'center'} >
                <Grid item>
                    <Typography variant='h2' sx={{ color: globals.colors.lightRed, fontSize: 25, fontWeight: 'bold', mb: 5 }}>Политика за възстановяване на суми (Refund Policy)</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item>
                    <Typography variant='h3' sx={{ color: globals.colors.darkBlue, fontSize: 13, fontWeight: 'bold', mt: 2 }}>
                        Последна актуализация: 12.08.2025
                    </Typography>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13, mt: 2 }}>
                        Всички текстове, изображения, графики, лога, софтуер и други материали, публикувани на сайта, са обект на
                        закрила от закона и са собственост на eAcademiabg Co освен ако изрично не е упоменато друго.
                    </Typography>
                    <Typography variant='h2' sx={{ color: globals.colors.lightRed, fontSize: 20, fontWeight: 'bold', mt: 2 }}>
                        1. Право на възстановяване за ученици
                    </Typography>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13, mt: 2 }}>
                        <ul>
                            <li><strong>Стандартен срок:</strong> Можеш да поискаш възстановяване на сумата за закупен курс или урок <strong>до 7 дни</strong> след плащането,
                                ако <strong>първият урок не е започнал</strong>.</li>
                            <li><strong>След стартиране на първия урок:</strong> Възстановяване <strong>не се извършва</strong>, освен при доказана вина на преподавателя или технически проблем
                                от страна на платформата.</li>
                            <li>При вина на преподавателя:
                                <ul>
                                    <li>Ако урок бъде отменен или не се проведе по вина на преподавателя, ученикът има право на <strong>безплатен урок</strong> или <strong>възстановяване на сумата</strong> за
                                        конкретния урок.
                                    </li>
                                </ul>
                            </li>
                            <li>При вина на ученика:
                                <ul>
                                    <li>Ако ученикът <strong>не уведоми поне 24 часа предварително</strong> (или 3 часа при спешност) за отсъствие, урокът се счита за проведен и сумата не се възстановява.</li>
                                </ul>
                            </li>
                        </ul>
                    </Typography>
                    <Typography variant='h2' sx={{ color: globals.colors.lightRed, fontSize: 20, fontWeight: 'bold', mt: 2 }}>
                        2. Процедура за заявка за възстановяване на суми
                    </Typography>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13, mt: 2 }}>
                        <ul>
                            <li>Свържи се с нас по имейл на info@eacademiabg.com или на телефон +359878852548.</li>
                            <li>eAcademiaBg ще потвърди получаването на заявката в рамките на <strong>1 работен ден.</strong></li>
                            <li>Обработката и решението за възстановяване се извършват до <strong>3 работни дни.</strong></li>
                        </ul>
                    </Typography>
                    <Typography variant='h2' sx={{ color: globals.colors.lightRed, fontSize: 20, fontWeight: 'bold', mt: 2 }}>
                        3. Начин на възстановяване
                    </Typography>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13, mt: 2 }}>
                        <ul>
                            <li>Възстановяването се извършва <strong>по същия метод на плащане</strong>, използван при покупката</li>
                            <li>Времето за получаване на сумата зависи от банката/платежната услуга (обикновено 5–14 работни дни).</li>
                            <li>eAcademiaBg не носи отговорност за забавяния, дължащи се на външни платежни оператори.</li>
                        </ul>
                    </Typography>
                    <Typography variant='h2' sx={{ color: globals.colors.lightRed, fontSize: 20, fontWeight: 'bold', mt: 2 }}>
                        4. Специални случаи
                    </Typography>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13, mt: 2 }}>
                        <ul>
                            <li>При прекратяване на профил от страна на eAcademiaBg поради нарушение на условията, <strong>не се дължи възстановяване на неусвоени плащания.</strong></li>
                            <li>При извънредни обстоятелства (здравословни причини, форсмажор) eAcademiaBg може да предложи:
                                <ul>
                                    <li>Частично възстановяване</li>
                                    <li>Прехвърляне на сумата като кредит за бъдещи уроци.</li>
                                </ul>
                            </li>
                        </ul>
                    </Typography>
                    <Typography  variant='h2' sx={{ color: globals.colors.lightRed, fontSize: 20, fontWeight: 'bold', mt: 2 }}>
                        Как да се свържете с нас?
                    </Typography>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13, mt:2}}>
                        Във връзка с възникнали въпроси, възражения, искания, свързани със спазването на задълженията по защита на личните данни може да ни пишете на електронен адрес: info@eacademiabg.com и тел. +359878852548.
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
}

export default RefundPolicyPage;